import useText from 'hooks/useText';
import { useCallback } from 'react';

/**
 * A deleted group (JBWEB-1434) keeps its name on the records linked to it
 * (tasks, notes): the api answers those links with `deleted: true`. Such a
 * link reads « name (supprimé) », greyed, and opens nothing: the group's page
 * answers GROUP_NOT_FOUND.
 */
export const isDeletedGroupLink = (link) =>
  link?.type === 'group' && link.deleted === true;

// A task without stored links has its group's link drawn from `task.group`
// (helper/taskLinks), which does not carry the flag over.
export const markDeletedGroup = (task) => (link) =>
  link?.type === 'group' &&
  !link.deleted &&
  task?.group?.deleted &&
  String(task.group.id) === String(link.id)
    ? { ...link, deleted: true }
    : link;

/** The name a link shows: « name (supprimé) » for a deleted group. */
export const useLinkLabel = () => {
  const { text } = useText('record');
  return useCallback(
    (link) =>
      isDeletedGroupLink(link)
        ? text('groupDeleted', { name: link.label })
        : link.label,
    [text],
  );
};
